import React from 'react';
import styled from "styled-components";
import drawings_bg from "../../images/drawings_bg.png";
import drawings_bg_1 from "../../images/drawings_bg_1.jpg";
import drawings_bg_2 from "../../images/drawings_bg_2.png";
import drawings_bg_3 from "../../images/drawings_bg_3.jpg";
import Breadcrumbs from "../../components/Breadcrumbs";
import JoinTeamForm from "../../components/JoinTeamForm";
import Advantages from "../../components/manufacturing/Advantages";
import {useMediaQuery} from "usehooks-ts";

const CapabilityBlock = styled.div<{ $blockId: number }>`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 28px 32px;
    grid-area: block_${({$blockId}) => $blockId};
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    background-color: ${({$blockId}) => [2, 8, 10].includes($blockId) ? "#EFF1FA" : "transparent"};

    @media screen and (max-width: 1919px) {
        padding: 24px 18px 24px 30px;
    }
    @media screen and (max-width: 999px) {
        padding: 26px 32px;
    }

    span {
        font-weight: 500;
        font-size: 18px;
        line-height: 140%;

        &:nth-child(1) {
            color: #5B77CB;
        }

        &:nth-child(2) {
            font-weight: 400;
        }
    }

    &.capability_title {
        padding: 0;
        gap: 11px;
        justify-content: flex-start;
        border: none;

        span {
            &:nth-child(1) {
                font-size: 28px;
                font-weight: 600;
                color: #000000;
                line-height: 100%;
                opacity: 73%;
            }

            &:nth-child(2) {
                color: #5b77cb;
                font-weight: 700;
                line-height: 100%;
                font-size: 108px;
                opacity: 10%;
            }

            @media screen and (max-width: 1919px) {
                &:nth-child(1) {

                }

                &:nth-child(2) {
                    font-size: 90px;
                }
            }
        }
    }
`;

const CapabilityImage = styled.img<{ $blockId: number, $src: string }>`
    border-radius: 10px;
    object-fit: cover;
    overflow: hidden;
    width: 100%;
    height: 100%;
    grid-area: image_block_${({$blockId}) => $blockId};
    background: url(${({$src}) => $src}) center / cover;
    @media screen and (max-width: 999px) {
        &:not(.cropped) {
            display: none;
        }
    }

    &.cropped {
        background-size: 150%;
        background-position-y: 65%;

        @media screen and (max-width: 1919px) {
            background-size: 160%;
            background-position-y: 90%;
        }
        @media screen and (max-width: 999px) {
            background-position: center !important;
            background-size: cover;
        }
    }
`;

const StyledManufacturingDrawings = styled.main`
    color: #171717;
    overflow: hidden;

    .examples-of-work {
        display: flex;
        gap: 44px;
        flex-direction: column;
        padding: 110px 0;
        align-items: center;

        @media screen and (max-width: 1919px) {
            display: none;
        }

        h2 {
            font-weight: 600;
            font-size: 28px;
            color: #000000;
            opacity: 73%;
        }

        .example-images {
            display: flex;
            gap: 30px;

            .img-wrap {
                display: flex;
                overflow: hidden;
                width: 380px;
                height: 220px;
                border-radius: 10px;
                filter: grayscale(1);
                transition: filter 200ms ease-in-out;

                &:hover {
                    filter: grayscale(0);
                }

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }

    .capabilities {
        display: grid;
        gap: 28px 30px;
        padding: 115px 0;
        grid-template-rows: repeat(5, 170px);
        grid-template-columns: repeat(3, 1fr);

        grid-template-areas: 
    "block_0 block_1 image_block_1"
    "block_2 block_3 image_block_1"
    "block_4 block_5 block_6"
    "image_block_2 block_7 block_8"
    "block_9 block_10 block_11";
        @media screen and (max-width: 1919px) {
            gap: 20px 16px;
            padding: 94px 0;

        }
        @media screen and (max-width: 999px) {
            grid-template-rows: repeat(6, 150px) 196px repeat(6, 150px);
            grid-template-columns: 1fr;
            gap: 20px;
            padding: 100px 0;
            grid-template-areas:
"block_0"
"block_1"
"block_2"
"block_3"
"block_4"
"block_5"
"image_block_2"
"block_6"
"block_7"
"block_8"
"block_9"
"block_10"
"block_11";
        }
    }

    .container {
        width: min(1200px, calc(100% - 40px));
        margin: 0 auto;

        &.top {
            margin-bottom: 35px;

            p {
                font-weight: 400;
                font-size: 18px;
                line-height: 140%;
            }
        }
    }

    h1, h2, p {
        margin: 0;
    }

    h1 {
        margin: 38px 0 42px;
        font-size: 28px;
        font-weight: 600;
        @media screen and (max-width: 1919px) {
            margin: 38px 0 28px;
        }
    }

    h2 {
        font-size: 28px;
        font-weight: 600;
    }

    .hero {
        width: min(1200px, calc(100% - 40px));
        min-height: 403px;
        margin: 0 auto;
        display: flex;
        align-items: flex-start;
        background: url(${drawings_bg}) center / cover;
        @media screen and (max-width: 1919px) {
            width: auto;
        }
        @media (max-width: 999px) {
            min-height: 311px;
        }
    }

    .contact {
        padding: 0 0 110px;
        @media screen and (max-width: 1919px) {
            padding: 0 0 90px;
        }
    }

    .contact h2 {
        margin-bottom: 20px;
    }

    .contact p {
        max-width: 610px;
        margin-bottom: 28px;
        font-size: 18px;
        line-height: 1.4;

        &:last-child {
            max-width: none;
            padding-top: 26px;
            font-weight: 400;
            margin-bottom: 0;

            a {
                font-weight: 500;
                color: #354D95;
            }
        }
    }

    .contact button {
        height: auto;
        padding: 16px 28px;
        border: 0;
        background: #5b77cb;
        color: white;
        font-weight: 500;
        font-size: 20px;
        border-radius: 4px;
        line-height: 140%;
    }

    .contact button:hover {
        background: #354d95 !important;
        color: white !important;
    }

    @media (max-width: 999px) {

        h1 {
            margin: 30px 0;
            font-size: 24px;
        }

        h2 {
            font-size: 24px;
        }

        .contact {
            padding-bottom: 106px;
        }
    }
`;

const advantagesItems = [{
    title: 'Собственные площадки',
    text: 'Для выполнения полного комплекса изготовления заказов без посредников.'
}, {
    title: 'Низкий процент брака',
    text: 'Строгий контроль на всех этапах производства гарантирует качество.'
}, {
    title: 'Собственная лаборатория',
    text: 'Аттестованная лаборатория контроля качества продукции.'
}, {
    title: 'Полная документация',
    text: 'Вся выпускаемая продукция сопровождается необходимой технической документацией и документом контроля качества и точности.'
}]


function ManufacturingDrawings() {
    const mediumSize = useMediaQuery('(max-width: 1919px)')

    return (
        <StyledManufacturingDrawings>
            <div className="container top">
                <Breadcrumbs/>
                <h1>Изготовление по вашим чертежам, эскизам и тех. заданию</h1>
                <p>Полный комплекс услуг по металлообработке, обеспечивая высокую точность, качество и своевременное
                    выполнение заказа</p>
            </div>
            <section className="hero"/>
            <section className={"container capabilities"}>
                <CapabilityBlock $blockId={0} className={"capability_title"}>
                    <span>Наши {mediumSize && <br/>} возможности</span>
                    <span>ЗАРЯ</span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={1}>
                    <span>01</span>
                    <span>
                        Механическая обработка на универсальных станках и станках ЧПУ
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={2}>
                    <span>02</span>
                    <span>
                        Изготовление измерительного инструмента, оснастки и шаблонов высокой точности
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={3}>
                    <span>03</span>
                    <span>
                        Выполнение заказов по Техническому заданию заказчика
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={4}>
                    <span>04</span>
                    <span>
                        Полный комплекс услуг
                        по металлообработке
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={5}>
                    <span>05</span>
                    <span>
                        Термообработка с высокой точностью разности закалки
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={6}>
                    <span>06</span>
                    <span>
                        Зуборезная обработка, изготовление шестерен
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={7}>
                    <span>07</span>
                    <span>
                        Электроэрозионная обработка
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={8}>
                    <span>08</span>
                    <span>
                        Сверлильные работы
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={9}>
                    <span>09</span>
                    <span>
                        Сварочные работы
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={10}>
                    <span>10</span>
                    <span>
                        Доводочные работы высокой точности
                    </span>
                </CapabilityBlock>
                <CapabilityBlock $blockId={11}>
                    <span>11</span>
                    <span>
                        Нанесение защитных покрытий
                    </span>
                </CapabilityBlock>
                <CapabilityImage $src={drawings_bg_1} $blockId={1}/>
                <CapabilityImage $src={drawings_bg_2} $blockId={2} className={"cropped"}/>
            </section>
            <section className="container contact">
                <JoinTeamForm title={"Изготовим детали по вашим чертежам"} text={"Оставьте заявку — и мы подготовим предложение с расчётом стоимости и сроков изготовления необходимых изделий."}/>
            </section>
            <Advantages items={advantagesItems}/>
            <div className="examples-of-work">
                <h2>Примеры наших работ</h2>
                <div className="example-images">
                    <div className="img-wrap">
                        <img src={drawings_bg_2} alt=""/>
                    </div>
                    <div className="img-wrap">
                        <img src={drawings_bg_3} alt=""/>
                    </div>
                </div>
            </div>
        </StyledManufacturingDrawings>
    );
}

export default ManufacturingDrawings;
